import React from "react";
import { DatePicker, Button, ConfigProvider } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/bg"; // Import Bulgarian locale
import localizedFormat from "dayjs/plugin/localizedFormat";
import bgBG from "antd/lib/locale/bg_BG"; // Import Bulgarian locale for antd

dayjs.extend(localizedFormat);

// Set the locale to Bulgarian
dayjs.locale("bg");

const DatePickerComponent = ({ date, setDate }) => {
  const currentDate = dayjs();
  const selectedDate = dayjs(date);
  const isPastDate = selectedDate.isSame(currentDate, "day");

  const disabledDate = (current) => {
    return current && current < currentDate.startOf("day");
  };

  return (
    <ConfigProvider locale={bgBG}>
      <div className="reservations-view-date-picker-container">
        <Button
          onClick={() => setDate((prevDate) => prevDate.subtract(1, "day"))}
          disabled={isPastDate}
        >
          -
        </Button>
        <DatePicker
          allowClear={false}
          value={date}
          format="dddd, D MMM"
          onChange={(value) => {
            setDate(value);
          }}
          inputReadOnly={true}
          disabledDate={disabledDate}
          className="reservations-view-date-picker"
        />
        <Button onClick={() => setDate((prevDate) => prevDate.add(1, "day"))}>
          +
        </Button>
      </div>
    </ConfigProvider>
  );
};

export default DatePickerComponent;
